import React from 'react';
import { Collapse, Table } from 'antd';
import { buildFinancialMetricColumns, formatParticulars } from '../../../helpers/helpers';

const Enterprise = ({ deal }) => {

  const enterpriseMetrics =
    deal?.metricsData?.Enterpise || deal?.metricsData?.Enterprise || {};
  const financialSummaryData = enterpriseMetrics?.["Financial Summary"] || [];
  const ratiosData = enterpriseMetrics?.["Ratios"] || [];

  const panelStyle = {
    marginBottom: 10,
    border: 'none',
  };

  const particularsRender = (text) => (
    <span style={{ color: '#40566D' }}>{formatParticulars(text)}</span>
  );

  const financialSummaryColumns = buildFinancialMetricColumns(
    financialSummaryData,
    particularsRender
  );
  const ratiosColumns = buildFinancialMetricColumns(ratiosData, particularsRender);

  const collapseItems = (panelStyle) => [
    {
      key: '1',
      label: 'Financial Summary',
      children: (
        <Table
          dataSource={financialSummaryData}
          columns={financialSummaryColumns}
          bordered
          pagination={false}
          scroll={{ x: 'max-content' }}
          className="custom-table"
        />
      ),
      style: panelStyle,
    },
    {
      key: '2',
      label: 'Ratios',
      children: (
        <Table
          dataSource={ratiosData}
          columns={ratiosColumns}
          bordered
          pagination={false}
          scroll={{ x: 'max-content' }}
          className="custom-table"
        />
      ),
      style: panelStyle,
    },
  ];

  return (
    <div className='enterprise-container'>
      <Collapse
        bordered={false}
        defaultActiveKey={['1']}
        items={collapseItems(panelStyle)}
        expandIconPosition='end'
        style={{ background: "#ffffff", width: '100%' }}
      />
    </div>
  );
};

export default Enterprise;
